<div class="page-wrapper" style="padding: 5rem;">
              <div class="col-lg-12 col-md-12">
  <main> 
        <div class="section-title mt-2">
          <h2>Budget Insights</h2>
          <div class="bar"></div>
        </div>
        <div class="about-content mb-4">
          <p>
            <strong>Budget Insights</strong> is a custom web-based application designed to assist management to monitor the implementation of their operating income and expenditure budgets.
            Budget variance analysis is the tool used inside Budget Insights to monitor how budgets are being implemented.
            Large variances, both positive and negative, are an indicator that budgets are not being properly implemented and corrective action needs to be taken.
          </p>
          <p>
            <strong>Budget Insights</strong> also includes a <strong>What-If analysis</strong> and <strong>scenario planning</strong> feature which allows for
            the mid-year forecasting of the <strong>income</strong> and <strong>expenditure budgets</strong>.
            Budget stress testing can also be carried out by using the What-If analysis feature to identify best-case and/or worst-case scenarios.

            Financial reporting, including ratio analysis, can be streamlined to improve mid-year reporting.
            The reporting also includes detailed variance analysis and year-on-year growth analysis for all income and expenditure items.
          </p>
          <p>
            The budget review process can also be significantly improved by implementing
            Budget Insights since the budget files from the application can be exported into a format that can be uploaded into any database or warehouse.
          </p>
        </div>
        <div><br><br><br><br>
          <iframe  style="width: 100%; height: 800px; border: 1px solid #ccc; border-radius: 10px;" 
  class="w-600" src="https://app.powerbi.com/view?r=eyJrIjoiZGVkYTU3MDQtNTEzYi00NDA0LWEzYzMtZWUxMzM3YjBmNmQwIiwidCI6IjRlMmZkZDA3LWVhNGUtNDYyNy1hZWYzLTVmZTJhM2MxMTEzOSJ9&pageName=ReportSection5a87980a05938b6954d4"
            allowfullscreen>
          </iframe>
        </div>
         </main>
</div>

</div>

  